import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { randomAvatar, comunidades } from "../../../utils/constants";
import ImageWithFallback from "./ImageWithFallback";

const PlayerInfo = ({ player, clanInfo, loadingClan }) => {
  const comunidad = player.comunidadAutonoma
    ? comunidades.find(c => c.id === player.comunidadAutonoma)
    : null;

  return (
  <Container>
    <Avatar>
      <ImageWithFallback
        key={`avatar-${player.playerId}`}
        src={player.discordAvatarURL || randomAvatar()}
        alt={player.username}
        fallbackSrc={randomAvatar()}
      />
    </Avatar>
    <Details>
      <UsernameLink to={`/player/${player.playerId}`}>
        {player.username}
      </UsernameLink>
      <DiscordName>{player.discordUsername}</DiscordName>
    </Details>
    {clanInfo && !loadingClan && (
      <ClanIcon src={clanInfo.image} alt={clanInfo.name} title={clanInfo.name} />
    )}
    {comunidad && (
      <ComunidadIcon src={comunidad.flagUrl} alt={comunidad.name} title={comunidad.name} style={comunidad.id === "valencia" ? { objectPosition: "15% center" } : {}} />
    )}
  </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const Avatar = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

const UsernameLink = styled(Link)`
  font-family: var(--v-font-body);
  font-size: 16px;
  font-weight: 600;
  color: var(--v-fg);
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    color: var(--v-hover);
  }
`;

const DiscordName = styled.span`
  font-family: var(--v-font-mono);
  font-size: 11px;
  color: var(--v-fg-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ClanIcon = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

const ComunidadIcon = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export default PlayerInfo;
